// extracted by mini-css-extract-plugin
export var legendIndicator = "_b8-1";
export var legendRight = "_b8-0";